module.exports = __webpack_public_path__ + "img/logo-feelgoodplus-tagline-swedish.26498692.svg";